import React from 'react';
import { Volume2 } from 'lucide-react';
interface FamilyMessageProps {
  sender: string;
  content: {
    type: 'text' | 'voice' | 'photo' | 'emotion';
    value: string;
  };
  avatar: string;
  time: string;
  onPlay?: () => void;
}
const FamilyMessage = ({
  sender,
  content,
  avatar,
  time,
  onPlay
}: FamilyMessageProps) => {
  // Get first name only for simpler display
  const firstName = sender.split(' ')[0];
  return <div className="flex items-start space-x-4 p-4 hover:bg-gray-50 dark:hover:bg-slate-700/50 
      rounded-2xl transition-all" data-id="element-65">
      <div className="relative" data-id="element-66">
        <img src={avatar} alt={firstName} className="w-16 h-16 rounded-2xl object-cover" data-id="element-67" />
        {content.type === 'emotion' && <div className="absolute -right-2 -bottom-2 text-2xl" data-id="element-68">
            {content.value.includes('thinking') ? '❤️' : content.value.includes('miss') ? '🌟' : content.value.includes('happy') ? '😊' : '👋'}
          </div>}
      </div>
      <div className="flex-1" data-id="element-69">
        <span className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-70">
          {firstName}
        </span>
        <div className="mt-2" data-id="element-71">
          {content.type === 'text' && <p className="text-xl text-gray-600 dark:text-gray-300" data-id="element-72">
              {content.value}
            </p>}
          {content.type === 'voice' && <button onClick={onPlay} className="flex items-center gap-3 bg-lavender/10 text-lavender 
                px-6 py-4 rounded-xl hover:bg-lavender/20 transition-all w-full" data-id="element-73">
              <Volume2 className="w-6 h-6" data-id="element-74" />
              <span className="text-lg" data-id="element-75">Listen</span>
            </button>}
          {content.type === 'photo' && <div className="mt-2 rounded-2xl overflow-hidden" data-id="element-76">
              <img src={content.value} alt="Shared moment" className="w-full h-56 object-cover" data-id="element-77" />
            </div>}
          {content.type === 'emotion' && <div className="inline-block bg-gray-100 dark:bg-slate-700 
              px-6 py-4 rounded-xl" data-id="element-78">
              <p className="text-2xl" data-id="element-79">
                {content.value.includes('thinking') ? '❤️ Thinking of you' : content.value.includes('miss') ? '🌟 Miss you' : content.value.includes('happy') ? '😊 Feeling happy' : content.value}
              </p>
            </div>}
        </div>
      </div>
    </div>;
};
export default FamilyMessage;